
window.addEventListener("load", function () {
   

});